
window.addEventListener("load", function () {
   

});